import { useState, useRef, useEffect } from "react";
import {
	ErrorScheme,
	ProductScheme,
	Subscription,
	SubscriptionScheme,
} from "client-v2";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";

import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import Success from "../../components/section/success/Success";
import SuccessRight from "../../components/section/success/SuccessCrossSell";
import Price from "../../components/section/donation/Price";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import SubscriptionSection from "../../components/section/donation/Subscription";
import { Modal, Text } from "@adoptaunabuelo/react-components";
import dayjs from "dayjs";

const Checkout = (props: Props) => {
	const dispatch = useDispatch();
	const { setShowError, setShowLoading } = bindActionCreators(
		actionsCreators,
		dispatch
	);
	const isMobile: boolean = useSelector(
		(state: State) => state.screen.isMobile
	);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "sb";
	const [product, setProduct] = useState<ProductScheme | undefined>(
		props.product
	);
	const [subscription, setSubscription] = useState<
		SubscriptionScheme | undefined
	>();
	const [showModal, setShowModal] = useState(false);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (currentUser) {
			setShowLoading(true);
			Subscription.get({
				userId: currentUser.objectId,
				descending: "createdAt",
				include: ["Product"],
				limit: 1,
				page: 0,
			})
				.then((result) => {
					if (result.data.length > 0) {
						setSubscription(result.data[0]);
					} else {
						wizard.current?.goNext();
					}
					setShowLoading(false);
				})
				.catch((e: ErrorScheme) => {
					setShowLoading(false);
					wizard.current?.goNext();
				});
		} else {
			wizard.current?.goNext();
		}
	}, [currentUser]);

	const onBackClick = (step: number) => {
		if (step === 6) {
			wizard.current?.goBack(1, step);
		}
	};

	const unpauseSubscription = () => {
		if (subscription && currentUser) {
			setLoading(true);
			Subscription.unpause({
				userId: currentUser.objectId,
			})
				.then((result) => {
					setLoading(false);
					setShowModal(false);
					wizard.current?.goNext(3);
				})
				.catch((e: ErrorScheme) => {
					setLoading(false);
					setShowModal(false);
					setShowError({ show: true, message: e.message });
				});
		}
	};

	return (
		<>
			<Modal
				isVisible={showModal}
				title="Vas a reactivar tu donación"
				buttonProps={{
					children: "Estoy de acuerdo",
					loading: loading,
					onClick: unpauseSubscription,
				}}
				onClose={() => setShowModal(false)}
			>
				<Text type="p" style={{ marginBottom: 24 }}>
					{`Tu aportación a la Fundación Adopta Un Abuelo se volverá a activar y el siguiente recibo se emitirá el próximo día ${dayjs(
						new Date()
					).format("DD/MM/YYYY")}`}
				</Text>
			</Modal>
			<WizardContainer
				ref={wizard}
				onBackClick={onBackClick}
				views={[
					//Subscription view
					{
						centralView: subscription && (
							<SubscriptionSection
								subscription={subscription}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										setProduct(result.data);
										if (subscription.state === "cancel")
											wizard.current?.goNext();
										else if (
											subscription.state === "paused"
										)
											setShowModal(true);
										else wizard.current?.goNext();
									}
								}}
							/>
						),
					},
					//Select price view
					{
						centralView: (
							<Price
								options={["monthly", "annually"]}
								amountSelector="slider"
								view={view}
								defaultProduct={
									props.product
										? props.product
										: subscription?.Product
								}
								title={
									"Ningún mayor debería sentirse solo. ¿Nos ayudas?"
								}
								subtitle={"Regalas {{value}} horas de compañía"}
								type_to_eur={0.602}
								subtitle_type={"horas"}
								onFinish={(result) => {
									if (result.error) {
										setShowError({
											show: true,
											message: result.error,
										});
									} else if (result.data) {
										setProduct(result.data);
										wizard.current?.goNext();
									}
								}}
							/>
						),
					},
					//Select payment method
					{
						centralView:
							product && currentUser ? (
								<PaymentMethod
									product={product}
									subscription={
										subscription?.state === "active"
											? subscription
											: undefined
									}
									user={currentUser}
									view={view}
									onFinish={(result) => {
										if (result.error) {
											setShowError({
												show: true,
												message: result.error,
											});
										} else if (result.data) {
											wizard.current?.goNext();
										}
									}}
									onProductChange={(result) => {
										if (result.error) {
											setShowError({
												show: true,
												message: result.error,
											});
										} else if (result.data) {
											setProduct(result.data);
										}
									}}
								/>
							) : null,
					},
					//Success view
					{
						centralView:
							currentUser && product ? (
								<Success
									user={currentUser}
									didSubscribe={product.charge}
									title={`¡Gracias por tu donación, ${currentUser.name}!`}
									subtitle="Con tu ayuda y la de otras muchas personas podremos acabar con la soledad de nuestros abuelos. ¡Sigamos así!"
									type="donation"
								/>
							) : null,
						rightView: !isMobile ? <SuccessRight /> : null,
						hideBackButton: true,
					},
				]}
			/>
		</>
	);
};
export default Checkout;
export interface Props {
	adminId?: string;
	product?: ProductScheme;
}
